import { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { settings } from '../../settings';
import { useTranslation } from 'react-i18next';
import TermsAndCondition from '../View/TermsAndCondition';
import { IBuildVersion } from '../../../types/IComponentTypes';

export default function Footer() {
  const { t } = useTranslation();

  const color: any = {
    Dev: 'bg-yellow',
    Prod: 'bg-gray',
    Test: 'bg-orange',
    Demo: 'bg-green',
  };
  const [value, setValue] = useState<IBuildVersion>();

  const getVersion = async () => {
    const response = await fetch('/Versioninfo.json');
    return await response.json();
  };

  useEffect(() => {
    getVersion().then((data) => {
      setValue(data);
    });
  }, []);

  return (
    <Grid className={`footer root ${color[settings.Environment]}`}>
      <Grid className="env">
        <span>
          {t('footer.env')}: {settings.Environment}
        </span>
      </Grid>
      <Grid className="termsAndConditionStyle">
        <TermsAndCondition />
        &nbsp;&nbsp;
        <span>
          <b>{t('footer.release')}</b>:{value?.release} | <b>{t('footer.sprint')}</b>:
          {value?.sprint} | <b>{t('footer.build')}</b>:{value?.build} | <b>{t('footer.branch')}</b>:
          {value?.branch} | <b>{t('footer.date')}</b>: {value?.date}
        </span>
      </Grid>
    </Grid>
  );
}
